import { memo } from 'react';
import { NodeProps, Node } from '@xyflow/react';

interface KafkaBrokerData extends Record<string, unknown> {
  zone: string;
}

type KafkaBrokerNodeType = Node<KafkaBrokerData, 'kafkaBroker'>;

// Invisible grouping container — just provides parentId anchor for Kafka topic nodes
const KafkaBrokerNode = memo((_: NodeProps<KafkaBrokerNodeType>) => {
  return null;
});

KafkaBrokerNode.displayName = 'KafkaBrokerNode';
export default KafkaBrokerNode;
